/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface SettingsOrganizationPermissions { 
    add: boolean;
    change: boolean;
    destroy: boolean;
    view: boolean;
}
export const SettingsOrganizationPermissions_add_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SettingsOrganizationPermissions_change_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SettingsOrganizationPermissions_destroy_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SettingsOrganizationPermissions_view_Validators: ValidatorFn[] =
    [  Validators.required, ];


